import './EmailBanner.less';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import EmailInput from 'ck-core-client/source/ui/form/EmailInput';
import RoundButton from 'ck-core-client/source/ui/RoundButton';

export default class EmailBanner extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			inputValue: '',
			inputError: '',
			closed: false,
			sent: false
		};
	}

	async emitEmail() {
		const { inputValue } = this.state;

		this.setState({
			shake: false
		});

		if (inputValue) {
			try {
				await this.props.handleSubmit(inputValue);

				this.setState({
					sent: true
				});
			} catch (e) {
				CK.logger.error(e);

				this.setState({
					shake: true
				});

				this.props.handleError && this.props.handleError(e);
			}
		} else {
			this.props.handleSkip && this.props.handleSkip();
		}
	}

	render() {
		const {
			title,
			emailText,
			buttonText,
			confirmationText,
			subtitle,
			backgroundImg,
			buttonColour
		} = this.props;

		const { inputError, inputValue, closed, sent, shake } = this.state;

		const style = {
			backgroundImage: `url(/graphics/backgrounds/${backgroundImg}.svg)`,
			backgroundSize: 'cover'
		};

		return (
			<div
				className={classnames(`EmailBanner`, closed ? 'EmailBanner--collapsed' : null)}
				style={style}
			>
				<div
					className={classnames(
						`EmailBanner__content`,
						closed || sent ? 'EmailBanner__content--collapsed' : null
					)}
				>
					<div className="EmailBanner__cell">
						<div className="EmailBanner__title">{title}</div>
						<div className="EmailBanner__subtitle">{subtitle}</div>
					</div>
					<div className="EmailBanner__cell">
						<div className={classnames(`EmailBanner__input`, shake ? 'EmailBanner__shake' : null)}>
							<EmailInput
								placeholder={emailText}
								noLabel
								name="email"
								valid={!inputError}
								error={inputError}
								value={inputValue}
								optional={true}
								onChange={inputValue => this.setState({ inputValue })}
							/>
						</div>
					</div>
					<div className="EmailBanner__cell">
						<RoundButton
							text={buttonText}
							size="medium"
							colour={buttonColour}
							handleClick={() => this.emitEmail()}
						/>
					</div>
				</div>
				<div
					className={classnames(
						`EmailBanner__sent`,
						!sent || closed ? 'EmailBanner__content--collapsed' : null
					)}
				>
					<div className="EmailBanner__title">{confirmationText}</div>
				</div>
				<div
					className={classnames(
						`EmailBanner__close`,
						closed ? 'EmailBanner__content--collapsed' : null
					)}
				>
					<ReactCKImage
						name="close-button"
						handleClick={() => this.setState({ closed: true })}
						options={{ width: '3rem', height: '3rem' }}
					/>
				</div>
			</div>
		);
	}
}

EmailBanner.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	emailText: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,
	confirmationText: PropTypes.string.isRequired,
	close: PropTypes.bool,
	backgroundImg: PropTypes.string,
	buttonColour: PropTypes.string,
	handleSubmit: PropTypes.func.isRequired,
	handleError: PropTypes.func,
	handleSkip: PropTypes.func
};
